import { useMemo } from 'react';
import { useAgreements } from '~/hooks/reactQuery/queries/useAgreements';
import { useClients } from '~/hooks/reactQuery/queries/useClients';
import { useLocaleKeys } from '~/i18n';
import { buildEntityMaps, resolveByValue, resolveEntityCell } from '../resolution/resolveEntity';
export const useAnalystEntityResolver = ()=>{
    const { t } = useLocaleKeys('analystAgent');
    const { clients } = useClients({
        refreshOnHookMount: true
    });
    const { agreements } = useAgreements({
        refreshOnHookMount: true
    });
    const agreementSeparator = t.resultTable.agreementLabelSeparator();
    const maps = useMemo(()=>buildEntityMaps(clients, agreements, agreementSeparator), [
        clients,
        agreements,
        agreementSeparator
    ]);
    return useMemo(()=>({
            resolve: (entityRef, cell)=>resolveEntityCell(entityRef, cell, maps),
            resolveByValue: (cell)=>resolveByValue(cell, maps)
        }), [
        maps
    ]);
};
